var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('TickerBanner',{attrs:{"ticker-items":_vm.tickerItems}}),_c('HeroSection'),_c('FreeBlindboxSection',{attrs:{"cards":_vm.blindBoxCards},on:{"card-click":_vm.onCardClick}}),_c('RusdRewardSection'),_c('PartnersSection'),_c('FaqSection'),_c('PromotionSection'),_c('RoadmapSection'),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }